import React from 'react';

const Footer = () => {
  return (
    <div className="text-center py-4">
      <p className="text-sm text-gray-400">
        © {new Date().getFullYear()} ALL RIGHTS RESERVED
      </p>
    </div>
  );
};

export default Footer;
